import React from "react";
import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal for editorial headlines.
 * Each "line" is a string. Lines slide up from below a mask on mount.
 * className applies to the whole block; lineClassName to each line span.
 */
export default function KineticHeading({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.09,
}) {
  return (
    <span className={`inline-block ${className}`} aria-label={lines.join(" ")}>
      {lines.map((ln, i) => (
        <span
          key={i}
          className="block overflow-hidden"
          style={{ lineHeight: 0.95 }}
        >
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * stagger,
            }}
            className={`block will-change-transform ${lineClassName}`}
          >
            {ln}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
